import { render, staticRenderFns } from "./TextOverflow.vue?vue&type=template&id=0d74afad&scoped=true"
import script from "./TextOverflow.vue?vue&type=script&lang=js"
export * from "./TextOverflow.vue?vue&type=script&lang=js"
import style0 from "./TextOverflow.vue?vue&type=style&index=0&id=0d74afad&prod&lang=scss"
import style1 from "./TextOverflow.vue?vue&type=style&index=1&id=0d74afad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d74afad",
  null
  
)

export default component.exports